import { ReactNode } from 'react'
import { Button, ButtonProps, GlobalToken } from 'antd'
import { ButtonSetsType } from '../ActionBarDisplay'
import IconGlobalApp from '../../../../../utils/IconGlobalApp'
import { mapCommonIcons } from '../../../../../utils/mapCommonIcons'

type IProps = {
  customText?: ReactNode
} & ButtonProps

/**
 * Generates dropdown style for the save button.
 * @param themeToken - The Antd global theme token.
 * @returns An object containing the dropdown items props.
 */
export const saveBtnDropDownStyle = (
  themeToken: GlobalToken
): ButtonSetsType['collapseProps'] => ({
  key: 'save',
  label: 'Lưu',
  icon: (
    <IconGlobalApp name={mapCommonIcons.save} color={themeToken['blue-6']} />
  ),
})

const SaveButton = ({ customText, ...props }: IProps) => (
  <Button
    icon={<IconGlobalApp name={mapCommonIcons.save} />}
    type="primary"
    htmlType="submit"
    {...props}
  >
    {customText || 'Lưu'}
  </Button>
)

export default SaveButton
